const pagecontent = {
  //     DBServer: "http://192.168.102.157:3008",
  //Geoserver:"http://192.168.102.157:9001/geoserver"  ,
  //  DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //   Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvan",
  title: "About",

  bodycontent:
    'One of the crucial activities taken up by NRSC under NHP is "Capacity Building" for various implementing agencies of the Central/State government department officers. In this activity, it is proposed to conduct two training programs of one week duration per year on Remote Sensing& Geographic Information System (RS & GIS) fundamentals. It is also planned to conduct two customized training programs of two weeks duration per year on RS & GISapplications in water resources management. ',
  //DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvannhp",
};
export default pagecontent;
